import React,{ useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import DivButton from '../DivButton/DivButton.jsx'

const StandardModalContent = ({
  okHandlerArg,
  closeSelf,
  cancelHandlerArg,
  thirdHandlerArg,
  okText = 'OK',
  cancelText = 'Cancel',
  okHandler = null,
  cancelHandler = null,
  messageContent = '',
  htmlContent = null,
  okDisabled = false,
  cancelDisabled = false,
  okClassName = 'btn-success',
  cancelClassName = 'btn-danger',
  thirdHandler = null,
  thirdText = '',
  thirdClassName = 'btn-success',
  thirdDisabled = false,
  'data-title': dataTitle,
  'data-toggle': dataToggle,
  'data-placement': dataPlacement,
  ...remainingProps
}) => {
  const dispatch = useDispatch()
  const messageContentRef = useRef()

  useEffect(() => {
    if(htmlContent) {
      // this allows passing strings with html tags from the api directly to UI messages that will properly render them
      messageContentRef.current.innerHTML=htmlContent
    }
  },[])

  const okHandlerWrapper = useCallback(() => {
    if (okHandler) {
      if (!okHandler(okHandlerArg, dispatch)) {
        closeSelf()
      }
    } else {
      closeSelf()
    }
  },[okHandler, okHandlerArg])

  const cancelHandlerWrapper = useCallback(() => {
    if (cancelHandler) {
      if (!cancelHandler(cancelHandlerArg, dispatch)) {
        closeSelf()
      }
    } else {
      closeSelf()
    }
  }, [cancelHandler, cancelHandlerArg])

  const thirdHandlerWrapper = useCallback(() => {
    if (thirdHandler) {
      if (!thirdHandler(thirdHandlerArg, dispatch)) {
        closeSelf()
      }
    } else {
      closeSelf()
    }
  },[thirdHandler, thirdHandlerArg])

  let buttonContainerClassName = 'standard-modal-button-container'

  return (
    <div className="standard-modal-content">
      <div className="message-content" ref={messageContentRef}>{messageContent}</div>
      <div className={buttonContainerClassName}>
        {cancelHandler != null
          ? (
          <DivButton
            className={'btn ' + cancelClassName}
            aria-label={`modal ${cancelText} button`}
            data-cy="pwnedOK"
            onClick={cancelHandlerWrapper}
            disabled={cancelDisabled}
          >
            {cancelText}
          </DivButton>
            )
          : null}
        {okHandler != null
          ? (
          <DivButton
            className={'btn ' + okClassName}
            aria-label={`modal ${okText} button`}
            onClick={okHandlerWrapper}
            disabled={okDisabled}
            data-title={dataTitle}
            data-toggle={dataToggle}
            data-placement={dataPlacement}
          >
            {okText}
          </DivButton>
            )
          : null}
        {thirdHandler != null
          ? (
          <DivButton
            className={'btn ' + thirdClassName}
            aria-label={`modal ${thirdText} button`}
            onClick={thirdHandlerWrapper}
            disabled={thirdDisabled}
          >
            {thirdText}
          </DivButton>
            )
          : null}
      </div>
    </div>
  )
}

StandardModalContent.propTypes = {
  // String to display in ok button
  okText: PropTypes.string,
  // String to display in cancel button
  cancelText: PropTypes.string,
  // callback function for okButton
  okHandler: PropTypes.func,
  // Arg to be passed back to okHandler callback function
  okHandlerArg: PropTypes.any,
  // callback function for cancel button
  cancelHandler: PropTypes.func,
  // Arg to be passed back to cancelHandler callback function
  cancelHandlerArg: PropTypes.any,
  // button enabled property
  okDisabled: PropTypes.bool,
  cancelDisabled: PropTypes.bool,
  // alternate classes for buttons
  okClassName: PropTypes.string,
  cancelClassName: PropTypes.string,
  // Primary message content
  messageContent: PropTypes.node,
  // These are for tooltip purposes
  'data-title': PropTypes.string,
  'data-toggle': PropTypes.string,
  'data-placement': PropTypes.string
}

export default StandardModalContent
